//how to create a multidemensional array in javascript?


let loadCollectionProducts = {
    lastPage: 0,
    target: '',
    instanceCounter: 0,
    init(){
        this.target = document.querySelector('.load-next-products');
        this.createObserver(this.target);
    },
    createObserver(element){
      let observer;

      let options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
      };

      observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
      observer.observe(element);
    },
    async getNextPage(next_url) {
        try {
            let res = await fetch(next_url);
            return await res.text();
        } catch (error) {
            console.log(error);
        }
    },
    handleIntersect (entries, observer){
      let container = document.querySelector('.grid-items-container:not(.collection-widget__blocks)');
      let cardHTML;
      let loadDiv = document.querySelector('.load-next-products');
      let pages = loadDiv.getAttribute('data-collection-items') / loadDiv.getAttribute('data-paginate');
      let currentPage = loadDiv.getAttribute('data-page');
      let nextPage = Number(currentPage) + 1;
      pages = Math.ceil(pages);

      entries.forEach(entry => {
        if(entry.isIntersecting){
          if(nextPage > pages){
            observer.disconnect();
          } else {
            loadDiv.classList.add('spinner');

            this.getNextPage(`${window.location.pathname}?page=${nextPage}${window.location.search.replace("?", "&")}`).then(resp => {
              if (this.lastPage != nextPage) {
                const parser = new DOMParser();
                const nextPageDoc = parser.parseFromString(resp, "text/html");

                const productgrid = nextPageDoc.querySelector(".grid--view-items:not(.collection-widget__blocks)");
                const new_products = productgrid.querySelectorAll("li.grid__item:not(.collection-widget-block)");

                /*
                for (const product of new_products) {
                  container.innerHTML += product.outerHTML;
                }
                 */
                container.append(...new_products)

                if (loadDiv.getAttribute('data-wholesale') == "true") {
                  let quant = $('.product-form__item input');

                  productPlusMinus.checkMinus(quant.val(), quant);
                  productPlusMinus.checkPlus(quant.val(), quant);
                }

                loadDiv.classList.remove('spinner');

                loadDiv.setAttribute('data-page', nextPage);

                var sections = new theme.Sections();
                sections.register('product', theme.Product);

                this.lastPage = nextPage;
                // Check if b2b and in list mode
                if(document.querySelector('#listViewToggle')) {
                  if(document.querySelector('#listViewToggle').checked) {
                    document.querySelector('.collection-products').querySelectorAll('spark-product-card').forEach((sparkCard) => {
                      sparkCard.setAttribute('mode-quick-buy', '');
                    })
                  } else {
                    document.querySelector('.collection-products').querySelectorAll('spark-product-card').forEach((sparkCard) => {
                      sparkCard.removeAttribute('mode-quick-buy');
                    })
                  }
                }
              }
            });
          }
        }
      });
    }
  }

  loadCollectionProducts.init();
